import React from 'react'
import Radio from '@material-ui/core/Radio'
import { withStyles } from '@material-ui/core/styles'
import { isMobile } from 'react-device-detect'

// ---- Styled Radio ----
const CustomRadio = withStyles({
  root: {
    marginTop: isMobile ? 8 : 6,
    padding: 0,
    '& svg': {
      width: isMobile ? 11 : 14,
      height: isMobile ? 15 : 21,
      marginLeft: isMobile ? 2 : 4,
      display: 'block',
      boxSizing: 'border-box',
    },
  },
})((props) => (
  <Radio
    color="default"
    disableRipple
    {...props}
    icon={
      <span
        style={{
          border: '2px solid #B0B0B0',
          width: isMobile ? 18 : 24,
          height: isMobile ? 18 : 24,
          borderRadius: '50%',
          display: 'inline-block',
          backgroundColor: '#fff',
        }}
      />
    }
    checkedIcon={
      <span
        style={{
          border: '2px solid #0C9D9D',
          width: isMobile ? 18 : 24,
          height: isMobile ? 18 : 24,
          borderRadius: '50%',
          display: 'inline-block',
          backgroundColor: '#fff',
          position: 'relative',
        }}
      >
        <span
          style={{
            width: isMobile ? 8 : 12,
            height: isMobile ? 8 : 12,
            borderRadius: '50%',
            backgroundColor: '#0C9D9D',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </span>
    }
  />
))

// ---- Usage Example with react-hook-form ----
export default function EasyPayPlanRadio({ checked }) {
  
  return <CustomRadio checked={checked} />
}
